import cx from 'classnames'

import { focusRingStyles } from '../../libs/focusRingStyles'
import { paperStyles } from '../../libs/paperStyles'
import { typographyStyles } from '../../structure/typography/styles'

export const disabledInputStyles = ({ isInError }: { isInError: boolean }) =>
  cx(
    isInError
      ? 'cursor-not-allowed bg-error-200 dark:bg-error-700 placeholder-error-800/50 dark:placeholder-error-300/50'
      : 'cursor-not-allowed bg-slate-200 dark:bg-slate-700 placeholder-amaze-ink/50 dark:placeholder-amaze-inkBright/50',
  )

export const inputTypographyStyles = ({
  isDisabled,
}: {
  isDisabled: boolean
}) => typographyStyles({ intensity: isDisabled ? 'tertiary' : 'primary' })

export const rawTextInputStyles = ({
  isInError,
  isAfterAddOn = false,
  disabled,
  focusRingVariant = 'default',
}: {
  isInError: boolean
  isAfterAddOn?: boolean
  disabled: boolean
  focusRingVariant?: Parameters<typeof focusRingStyles>[0]['variant']
}) =>
  cx(
    inputTypographyStyles({ isDisabled: disabled }),
    focusRingStyles({ hasError: isInError, variant: focusRingVariant }),
    'truncate', // clearly show that text is overflowing
    'field-sizing-content', // allows to grow based on content - needed in e.g. tablecell inputs
    'min-w-20', // prevent text like inputs from becoming too narrow unless deliberately styled otherwise
    'w-full rounded-md px-2 py-1.5 text-left transition',
    'border-none outline-hidden', // override browser default
    'focus:z-1', // to ensure focus ring is above the addon
    isAfterAddOn && 'min-w-0 grow rounded-l-none',
    {
      disabledInError: cx(disabledInputStyles({ isInError: true })),
      disabledNotInError: cx(disabledInputStyles({ isInError: false })),
      enabledInError: cx(
        'placeholder-error-800/50 dark:placeholder-error-300/50',
        'text-error-500! selection:bg-error-500',
        'hover:shadow-sm shadow-error-500/20',
        paperStyles({ ringColor: 'error' }),
      ),
      enabledNotInError: cx(
        'placeholder-amaze-ink/50 dark:placeholder-amaze-inkBright/50',
        'hover:shadow-sm',
        paperStyles({ ringColor: 'grey' }),
      ),
    }[
      `${disabled ? 'disabled' : 'enabled'}${isInError ? 'InError' : 'NotInError'}`
    ],
  )
